import React, { useContext } from 'react';

import {
  VIEW_MODE_DATATABLE,
  VIEW_MODE_TILES,
} from 'scenes/Gallery/ConversionPages/constants';

import ConversionGroupsTiles from './ConversionGroupsTiles';
import GroupsDataTableOriginal from './ConversionGroupsDataTable';
import ConversionGroupsDataTableContext, {
  ConversionGroupsDataTableProvider,
  useGroupsCount,
} from './ConversionGroupsDataTableContext';

export {
  ConversionGroupsDataTableContext,
  ConversionGroupsDataTableProvider,
  useGroupsCount,
};

export const GroupsDataTable = ({ height, tabs }) => {
  const { viewMode } = useContext(ConversionGroupsDataTableContext);

  return {
    [VIEW_MODE_DATATABLE]: (
      <GroupsDataTableOriginal height={height} tabs={tabs} />
    ),
    [VIEW_MODE_TILES]: <ConversionGroupsTiles height={height} tabs={tabs} />,
  }[viewMode];
};
